import { getEnvParam } from 'env'

const getPersonaDomain = (): string | null => {
  const userInternalEmail = getEnvParam('userInternalEmail') as string | null
  const userEmail = getEnvParam('userEmail') as string | null
  if (userInternalEmail && userInternalEmail !== userEmail) {
    return userInternalEmail.split('@')[1]
  }
  return null
}

export const isPersonaEmail = (email: string): boolean => {
  const personaDomain = getPersonaDomain()
  if (!personaDomain) return false
  return email.endsWith(personaDomain)
}

export const getDisplayEmailFromPersonaEmail = (email: string): string => {
  return email.split('@')[0].replace('_at_', '@')
}
